import _getAppName from "../functions/helpers/getAppName.js";
import _ttmlFunc from "../functions/profiles/ttmlGeneral.js";
import { XMLParser as _XMLParser } from "fast-xml-parser";
import { decode as _decodeHtml } from "html-entities";
import _eol from "eol";
import _convertToPlainTextCustom from "../functions/quill/convertToPlainTextCustom.js";
import _convertToPlainText from "../functions/quill/convertToPlainText.js";
import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
import _tcLib from "../lib/timecode.js";
const tcLib = _tcLib;
const removeInvalidEvents = _removeInvalidEvents;
const getFormatOptions = _getFormatOptions;
const convertToPlainText = _convertToPlainText;
const convertToPlainTextCustom = _convertToPlainTextCustom;
const eol = _eol;
const decodeHtml = _decodeHtml;
const XMLParser = _XMLParser; //Decode
const ttmlFunc = _ttmlFunc;
const getAppName = _getAppName;
const getRegion = function (index, style) {
  let region = ttmlFunc.eventStyleMap[style];
  if (region === "pop") {
    return region + (index + 1);
  } else if (region === "paint") {
    if (index === 0) {
      return region;
    } else {
      return region + (index + 1);
    }
  } else if (region === "rollup") {
    return style.replace("-", "").replace(" ", "").toLowerCase();
  } else {
    return region + (index + 2);
  }
};
export default {
  decode: function (input, options) {
    let events = [],
      displays = [],
      regions = {},
      paragraphs = [],
      timeBase = "media",
      useClockTime = false,
      defaultRegion,
      defaultRegionId,
      defaultStyle;
    const xmlToJson = new XMLParser({
      stopNodes: ["*.p"],
      numberParseOptions: {
        skipLike: /[0-9]+/
      },
      ignoreAttributes: false
    });
    let fileJson = xmlToJson.parse(input);
    //if the fileJson is missing the tt element we need to add it in
    if (!fileJson.tt) {
      fileJson = {
        tt: fileJson
      };
    }
    timeBase = ttmlFunc.getTimeBaseValue(input) || "media";
    useClockTime = timeBase === "media" || timeBase === "clock" ? true : false;

    // console.log(JSON.stringify(fileJson, null, 4));
    try {
      if (fileJson.tt.head.layout && fileJson.tt.head.layout.region) {
        //Make sure regions is an array
        if (!Array.isArray(fileJson.tt.head.layout.region)) {
          fileJson.tt.head.layout.region = [fileJson.tt.head.layout.region];
        }
        fileJson.tt.head.layout.region.forEach(region => {
          regions[region['@_xml:id']] = region;
        });
      }
    } catch (err) {
      console.log("Unable to decode region data");
    }
    const addParagraph = function (paragraph, inheritedRegionId) {
      paragraphs.push({
        paragraph: paragraph,
        inheritedRegionId: inheritedRegionId
      });
    };
    if (Array.isArray(fileJson.tt.body.div)) {
      fileJson.tt.body.div.forEach(paragraphGroup => {
        let paragraphGroupRegionId = paragraphGroup["@_region"];
        if (Array.isArray(paragraphGroup.p)) {
          paragraphGroup.p.forEach(paragraph => {
            addParagraph(paragraph, paragraphGroupRegionId);
          });
        } else {
          addParagraph(paragraphGroup.p, paragraphGroupRegionId);
        }
      });
    } else {
      if (fileJson.tt.body.div['@_region']) {
        defaultRegionId = fileJson.tt.body.div['@_region'];
        defaultRegion = regions[defaultRegionId];
      }
      if (fileJson.tt.body.div['@_style']) {
        defaultStyle = regions[fileJson.tt.body.div['@_style']];
      }
      if (Array.isArray(fileJson.tt.body.div.p)) {
        fileJson.tt.body.div.p.forEach(paragraph => {
          addParagraph(paragraph, defaultRegionId);
        });
      } else {
        addParagraph(fileJson.tt.body.div.p, defaultRegionId);
      }
    }
    paragraphs.forEach(paragraphInfo => {
      let paragraph = paragraphInfo.paragraph;
      if (!paragraph["#text"]) {
        paragraph["#text"] = "";
      }
      let ccDisplay = new ttmlFunc.singleLine.Display();
      let start = tcLib.parseTcToSec(paragraph["@_begin"], options.frameRate, options.dropFrame, useClockTime);
      let end = tcLib.parseTcToSec(paragraph["@_end"], options.frameRate, options.dropFrame, useClockTime);
      //console.log(start,end);

      paragraph["#text"] = paragraph["#text"].toString();
      let original = decodeHtml(paragraph["#text"]);
      // console.log("------")
      // console.log("Original:",original);
      let text = convertToPlainText(original);
      // console.log("Text:",text);
      let html = ttmlFunc.multiLine.formatText(original);
      //console.log("html:",html);
      let originX,
        originY,
        extentX,
        extentY,
        region = defaultRegion;
      let regionId = paragraph["@_region"] || paragraphInfo.inheritedRegionId;
      let style = ttmlFunc.getStyleFromRegionId(regionId);
      if (regionId && regions) {
        region = regions[regionId];
      }
      if (paragraph["@_tts:origin"]) {
        originX = parseFloat(paragraph["@_tts:origin"].split(" ")[0].replace("%", ""));
        originY = parseFloat(paragraph["@_tts:origin"].split(" ")[1].replace("%", ""));
      } else if (region && region["@_tts:origin"]) {
        originX = parseFloat(region["@_tts:origin"].split(" ")[0].replace("%", ""));
        originY = parseFloat(region["@_tts:origin"].split(" ")[1].replace("%", ""));
      }
      if (paragraph["@_tts:extent"]) {
        extentX = parseFloat(paragraph["@_tts:extent"].split(" ")[0].replace("%", ""));
        extentY = parseFloat(paragraph["@_tts:extent"].split(" ")[1].replace("%", ""));
      } else if (region && region["@_tts:extent"]) {
        extentX = parseFloat(region["@_tts:extent"].split(" ")[0].replace("%", ""));
        extentY = parseFloat(region["@_tts:extent"].split(" ")[1].replace("%", ""));
      }
      if (displays.length > 0 && displays[displays.length - 1].start === start) {
        if (displays[displays.length - 1].style === "Pop-On" && style !== "Pop-On") {
          displays[displays.length - 1].style = style;
        }
        displays[displays.length - 1].insertLine({
          text: text,
          html: html,
          original: original,
          extentX: extentX,
          extentY: extentY,
          originX: originX,
          originY: originY,
          region: region
        });
      } else {
        ccDisplay.start = start;
        ccDisplay.end = end;
        ccDisplay.style = style;
        ccDisplay.insertLine({
          text: text,
          html: html,
          original: original,
          extentX: extentX,
          extentY: extentY,
          originX: originX,
          originY: originY,
          region: region
        });
        displays.push(ccDisplay);
      }
    });

    // console.log(JSON.stringify(displays, null, 4));
    displays.forEach(display => {
      let event = ttmlFunc.singleLine.decodeDisplay(display, options.window);
      event.style = display.style;
      events.push(event);
    });

    // console.log(JSON.stringify(events, null, 4));
    return events;
  },
  encode: function (eventGroup, options) {
    let encodingOptions = getFormatOptions(options.formatOptions);
    let languageCode = encodingOptions["Language Code"] || "en";
    let fontFamily = encodingOptions["Font Family"] || "monospace";
    let fontSize = encodingOptions["Font Size"] || 80;
    let fontWeight = encodingOptions["Font Weight"] || "normal";
    let fontColor = encodingOptions["Font Color"] || "white";
    let backgroundColor = encodingOptions["Background Color"] || "black";
    let tcFormat = encodingOptions["Timecode Format"] || "smpte";
    let timeBase = encodingOptions["Time Base"] || "media";
    let frameRateMultiplier = ttmlFunc.frameRateMultiplierMap[options.frameRate];

    // console.log(JSON.stringify(eventGroup, null, 4));

    let output = eol.after(`<?xml version="1.0" encoding="UTF-8"?>`);
    output += eol.after(`<tt xml:lang="${languageCode}"
        xmlns="http://www.w3.org/ns/ttml"
        xmlns:tts="http://www.w3.org/ns/ttml#styling"
        xmlns:ttm="http://www.w3.org/ns/ttml#metadata"
        xmlns:smpte="http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt"
        xmlns:m608="http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt#cea608"
        xmlns:ttp="http://www.w3.org/ns/ttml#parameter"
        ttp:timeBase="${timeBase}" ttp:frameRate="${ttmlFunc.frameRateMap[options.frameRate]}" ttp:frameRateMultiplier="${frameRateMultiplier}">`);
    output += eol.after(`<head>`);
    output += eol.after(`<metadata>`);
    output += eol.after(`<ttm:desc>${getAppName()}</ttm:desc>`);
    output += eol.after(`<smpte:information
        xmlns:m608="http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt#cea608"
        origin="http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt#cea608"
        mode="Preserved" m608:channel="CC1" m608:programName="Demo" m608:captionService="F1C1CC"
       />`);
    output += eol.after(`</metadata>`);
    output += eol.after(`<styling>
        <style xml:id='basic' tts:color='${fontColor}' tts:backgroundColor='${backgroundColor}' tts:fontFamily='${fontFamily}' tts:fontSize='${fontSize}%' tts:fontWeight="${fontWeight}"/>
       </styling>`);
    output += eol.after(`<layout>
        <region xml:id='pop1' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
        <region xml:id='pop2' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
        <region xml:id='pop3' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
        <region xml:id='pop4' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
        <region xml:id='paint' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
        <region xml:id='paint2' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
        <region xml:id='paint3' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
        <region xml:id='paint4' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
        <region xml:id='rollup2' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
        <region xml:id='rollup3' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
        <region xml:id='rollup4' tts:backgroundColor='transparent' tts:showBackground='whenActive'></region>
       </layout>`);
    output += eol.after(`</head>`);
    output += eol.after(`<body>`);
    output += eol.after(`<div>`);
    eventGroup.events.forEach(event => {
      // console.log(event);
      let start, end;
      if (tcFormat.toLowerCase() === "smpte") {
        start = timeBase == "smpte" ? tcLib.secToTc(event.start, options.frameRate, options.dropFrame) : tcLib.secToTcClock(event.start, options.frameRate, options.dropFrame);
        end = timeBase == "smpte" ? tcLib.secToTc(event.end, options.frameRate, options.dropFrame) : tcLib.secToTcClock(event.end, options.frameRate, options.dropFrame);
      } else {
        start = tcLib.secToTcMs(event.start, options.frameRate, options.dropFrame);
        end = tcLib.secToTcMs(event.end, options.frameRate, options.dropFrame);
      }
      let plainTextCustom = convertToPlainTextCustom(event.text, "\n", false, "strong", "em", "u", true);
      eol.split(plainTextCustom).forEach((textLine, index, textLines) => {
        let region = getRegion(index, event.style);
        let extents = ttmlFunc.singleLine.calcExtents(textLine, options.window, parseFloat(fontSize));
        let origins = ttmlFunc.singleLine.calcOrigin(event, textLine, index, textLines.length, parseFloat(fontSize), options.window);
        output += eol.after(`<p region='${region}' style='basic' begin='${start}' end='${end}' tts:origin='${origins}' tts:extent='${extents}'>${ttmlFunc.singleLine.convertToTtml(textLine)}</p>`);
      });
    });
    output += eol.after(`</div>`);
    output += eol.after(`</body>`);
    output += eol.after(`</tt>`);
    return output;
  },
  preProcess: {
    encode: function (eventGroup) {
      return removeInvalidEvents(eventGroup);
    },
    decode: function (input) {
      return eol.lf(input.trim());
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      return eventGroup;
    }
  }
};